import { Component, OnInit, input } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { AppHelper } from '@shared-helpers/appHelper';
import { ExpertModel } from '@shared-model/expert/ExpertModel';

@Component({
  selector: 'fourd-expert-image',
  templateUrl: './expert-image.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class ExpertImageComponent extends BaseComponent implements OnInit {
  readonly expert = input<ExpertModel>(undefined);
    
  constructor() { super("ExpertImageComponent"); }

  ngOnInit() {

  }

  getMimeType(thumbnailFileName: string) {
    return AppHelper.getImageMimeTypeFromFilename(thumbnailFileName);
  }

}
